import { Session, EntityRequest, SessionType } from './programs.data';
import { JoiFile } from './files.model';
import { JustTime, AllSameKeyValuesEnforcer } from '../helpers/helpers';
import { InformableSectionItem } from './informables.data';
import { Asset } from './assets.data';

export type OnsiteScheduleType = 'schedule' | 'program' | 'SubSchedule'
export type OnsiteScheduleSubtype = 'program' | 'programExtension' | 'standalone' | 'standaloneExtension'

/*
export interface BaseSchedule {
  dayAfterActivities: string[][]
  dayBeforeActivities: string[][]
}

export interface ProgramSchedule extends BaseSchedule {
  activities: string[][] // first entry is day 1 of program, etc
}

export interface MultiLaneProgramSchedule { // man, what a piece of shit this is.
  id: string
  title: string
  schedules: ProgramSchedule[] // by lane
}

export interface StandaloneSchedule extends BaseSchedule {
  date: string
  venueId?: string
  timeZoneId?: string
  activities: string[] // only one standard day of activities for standalone schedule
}


export interface NewOnsiteData {
  activities: { [activityId: string]: OnsiteActivity }
  standalones: { [scheduleId: string]: StandaloneSchedule }
}
*/

export interface OldOnsiteData {
  oseActivities: OnsiteActivity[]
  oseSchedules: OnsiteSchedule[]
}

export interface NewOnsiteData {
  activities: { [activityId: string]: OnsiteActivity }
  schedules: { [activityId: string]: OnsiteSchedule }
}

export interface OnsiteSchedule {
  date?: string
  extension?: number | boolean
  sessions?: any[]
  day?: number
  id?: string
  location?: string
  scheduleId: string
  order: number
  title?: string
  venueId?: string
  type: OnsiteScheduleType
  timeZoneId?: string
}

interface ActivityTabs { info, tagging, assets }
export const activityTabs: AllSameKeyValuesEnforcer<ActivityTabs> = { info: 'info', tagging: 'tagging', assets: 'assets' }

export type OnsiteBrickType = 'access' | 'activity' | 'clear' | SessionType
interface OnsiteBrickSharedAttributes { // some of these are just duplicates to get templates to accept a given type
  venueId?: string
  start?: string
  end?: string
  isStandalone?: boolean
  completed?: boolean
  program_scheduleId?: string
  program_type?: OnsiteScheduleType
  program_timeZoneId?: string
  scheduleId?: string
  duration?: number
  publicLinks?: JoiFile[]
  program_title?: string
  program_location?: string
  includeAddAssetLinkWhenActive?: { [performerId:string]: boolean }
  hideVenueAddress?: boolean
  hideVenueName?: boolean
  schedule_title?: string
  scheduleOrder?: number
  notes?: string;
  presentationNotes?: InformableSectionItem[]
  presentationAssets?: Asset[]
  otherAssets?: Asset[]
  stagingRequests?: EntityRequest[]
  assetIds?: string[]
  time?: string
  description?: string
  performerIds?: string[]
  labels?: string[]
  files?: Array<JoiFile>;
  sponsorIds?: string[]
  type: OnsiteBrickType
}

export interface OnsiteSession extends Session, OnsiteBrickSharedAttributes  {
  venueId?: string,
  type: SessionType
}

export interface ManageActivityData {
  activityId: string,
  readOnly?: boolean,
  date: Date,
  scheduleTitle: string,
  location: string
  assetIds?: string[]
  assetTitle?: string // for manage asset
}


export interface BaseOnsiteActivity {
  createdBy?: string
  description?: string
	extension?: boolean
  day?: number
	date?: Date
	files?: JoiFile[]
	id: string
	labels?: Array<string>
  linkId: string
  performerIds?: string[]
  exhibitorIds?: string[]
  sponsorIds?: string[]
  resourceIds?: string[]
  attendeeIds?: string[]
  tags?:string[]
  groupTags?:string[]
  justTime?: JustTime
  top?: number
  position?: number
  title: string
  type: 'activity'
  time?: string
  completed?: boolean
  assetIds?: string[]
}

export interface OnsiteActivity extends BaseOnsiteActivity, OnsiteBrickSharedAttributes {
  type: 'activity'
}

export interface OnsiteSetupBlock {
  title: string
  id: string

}

export interface OnsiteAccess extends OnsiteBrickSharedAttributes, OnsiteSetupBlock {
  type: 'access'
}
export interface OnsiteClear extends OnsiteBrickSharedAttributes, OnsiteSetupBlock {
  type: 'clear'
}

export type OnsiteTimelineBrick = OnsiteSession | OnsiteActivity | OnsiteAccess | OnsiteClear

export interface OnsiteSingleTimeline {
  date: any;
  dateId: string
  dayDate?: string;
  bricks: OnsiteTimelineBrick[]
}

export interface OnsiteProgram extends OnsiteSchedule {

  labels?: string[]
  sessions: OnsiteTimelineBrick[]
  timeZoneId: string
  venueId: string
  order: number
  session_labels?: string[]
  subType?: OnsiteScheduleSubtype // the types that I need to know for filtering
  performerTags?: string[]
  sponsorTags?: string[]
  exhibitorTags?: string[]
  workforceTags?: string[]
  resourceTags?: string[]
  attendeeTags?: string[]
}

export interface DLLNode<T> { // Double Linked List Node
  data: T
  prev?: DLLNode<T>
  next?: DLLNode<T>
}


export interface ProgramNode {
  // program nodes include "programs with session data (or not in case of extensions) as well as standalone schedules"
  schedule: OnsiteProgram //
  prev?: ProgramNode
  next?: ProgramNode
  day: number
  extension?: boolean
  standalone?: boolean
  subschedules?: OnsiteProgram[]
}

export type ProgramNodeMap = Map<String, ProgramNode> // needs to be a proper map so that keys and values can be used

export interface ProgramNodeDateMap {
  [date: string]: ProgramNodeMap
}


export interface OnsiteScheduleEntry {
  id: string,
  date: Date
}

export interface OnsiteLane {
  laneId: string
  type: string
  blocks: OnsiteBlock[][]
  height?: number
  title: string
  location?: string
  day?: number
  standalone?: boolean
  extension?: number | boolean
}

export interface OnsiteBlock {
	originalHeight?: number;
	start?: string
  end?: string
  startTime: JustTime
  endTime: JustTime
  startMinute: number
  endMinute: number
	top?: number;
  height?: number;
	type: SessionType | 'access' | 'clear' | 'activity'
	id?: string 
	title: string
  completed?: boolean
  containedActivities?: number
  immediatePredecessorEndMinute: number // needs to be initialized to -1
	duration: number
	labels?: string[]
  position?: number
  time?: string
}

export const sortActivityBlock = block => block.sort((a1, a2) => a1.time < a2.time ? -1 : 1)

export const oldOnsiteDataToNewOnsiteData = (onsiteData: OldOnsiteData): NewOnsiteData => {
  const activities = onsiteData.oseActivities || []
  const schedules = onsiteData.oseSchedules || []
  const newOnsiteData: NewOnsiteData = { activities: {}, schedules: {}}
  activities.forEach(a => newOnsiteData.activities[a.id] = a);
  schedules.forEach(s => newOnsiteData.schedules[s.id] = s);
  return newOnsiteData
}